import { render, staticRenderFns } from "./ManageEodTemplates.vue?vue&type=template&id=7c973e80&"
import script from "./ManageEodTemplates.vue?vue&type=script&lang=js&"
export * from "./ManageEodTemplates.vue?vue&type=script&lang=js&"
import style0 from "./ManageEodTemplates.vue?vue&type=style&index=0&id=7c973e80&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports